import React, { useEffect, useState } from "react";
import { PiCaretRightBold } from "react-icons/pi";
import MembersPanel from "./MembersPanel";
import "../../styling/Dashboard.css";
import { EventDataContext } from "../EventDataContext";
import { useContext } from "react";

const RightPanel = ({
  latestEvent,
  teamMembers, 
  onPanelEventClick,
  rightPaneEventClick,
  setSelectedMenuItem,
}) => {
  const { EventData, setEventData } = useContext(EventDataContext);

  const createDates = (latestEvent) => {
    return latestEvent?.slice(0, 3).map((event) => {
      const date = new Date(event.eventDate);
      return date.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
    });
  };

  let dates = createDates(latestEvent);
  const handleViewAllClick = () => {
    setSelectedMenuItem("Bookings");
  };
  return (
    // Wrapper container with a transparent background and a 20px gap
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      
      {/* --- PANEL 1: NEW BOOKINGS --- */}
      <div className="right-panel">
        <h3
          style={{
            color: "#000",
            marginTop: "0px",
            fontWeight: "500",
            fontSize: "20px",
            paddingTop: "10px",
          }}
        >
          New Bookings
        </h3>

        {/* Use .map() to avoid manually repeating JSX */}
        {latestEvent?.slice(0, 3).map((event, index) => (
          <div
            className="right-panel-content"
            key={event.id || `event-${index}`}
            onClick={() => {
              if (onPanelEventClick) {
                onPanelEventClick(event);
                setEventData(event);
              } else if (rightPaneEventClick) {
                rightPaneEventClick(event);
              }
            }}
            style={{ cursor: "pointer" }}
          >
            <h4
              style={{
                color: "#1C1154",
                marginTop: "0px",
                marginBottom: "5px",
                fontWeight: "400",
              }}
            >
              {event.eventName}
            </h4>
            <div className="right-panel-arrow-container">
              <span>{dates[index]}</span>
              <PiCaretRightBold className="right-panel-content-icon" />
            </div>
            <div style={{ paddingTop: "3px", paddingBottom: "15px" }}>
              {event.clientName}
            </div>
          </div>
        ))}

        <div style={{ marginTop: "15px" }}>
          <button className="createButtonStyleRP" onClick={handleViewAllClick}>
            View All
          </button>
        </div>
      </div>

      {/* --- PANEL 2: TEAM MEMBERS --- */}
      <div className="right-panel">
        <MembersPanel
          teamMembers={teamMembers}
          onAddTeamMemberClick={() => {
            setSelectedMenuItem('company');
            setTimeout(() => {
              window.location.hash = "#team-members";
            }, 1000); // Thoda delay taaki page pehle load ho jaaye
          }}
        />
      </div>

    </div>
  );
};

export default RightPanel;
